import { render, staticRenderFns } from "./choosing.vue?vue&type=template&id=cfde7ecc&scoped=true&"
import script from "./choosing.vue?vue&type=script&lang=js&"
export * from "./choosing.vue?vue&type=script&lang=js&"
import style0 from "./choosing.vue?vue&type=style&index=0&id=cfde7ecc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfde7ecc",
  null
  
)

export default component.exports